import { FormControl } from 'baseui/form-control'
import { SIZE } from 'baseui/input'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import getError from '@/containers/SubscriptionFormPage/getError'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'

const NumberOfOccupants = () => {
  const { t, energyLandscape, updateAddressEnergyLandscape, errors } = useAddress()
  return (
    <FormControl error={getError('occupantsNumber', errors)}>
      <SDInput
        label={t('subscriptionTools:estimator.occupants_number.label')}
        size={SIZE.compact}
        currentValue={energyLandscape?.numberOfOccupants}
        pattern={'[0-9]+'}
        min={'1'}
        max={'7'}
        onBlur={numberOfOccupants => updateAddressEnergyLandscape({ numberOfOccupants })}
      />
    </FormControl>
  )
}

export default NumberOfOccupants
